import React from 'react';
import { CheckIcon } from 'lucide-react';
import { forYou } from '../data/masterclass';
export function WhoThisIsFor() {
  return <section aria-labelledby="for-heading" className="border-t border-ink-line bg-ink" data-id="element-143" data-mp="34xo93xqocrko">
      <div className="mx-auto grid w-full max-w-6xl gap-10 px-6 py-16 lg:grid-cols-[1fr_1.1fr] lg:gap-16 lg:py-20" data-id="element-144" data-mp="2q8s120ombek2">
        <div data-id="element-145" data-mp="2v6bgh3x1xxdl">
          <p className="text-[11px] font-bold uppercase tracking-overline text-gold" data-id="element-146" data-mp="2h8mv7uz2oo80">
            Who this is for
          </p>
          <h2 id="for-heading" className="mt-4 font-display text-4xl font-bold uppercase leading-tight text-white sm:text-5xl" data-id="element-147" data-mp="2m7zujf74rnrh">
            This is for the couple who has something worth protecting.
          </h2>
        </div>

        <div data-id="element-148" data-mp="2cbd9apaw6uox">
          <ul className="space-y-4" data-id="element-149" data-mp="5jc56rajkznk">
            {forYou.lines.map(line => <li key={line} className="flex items-start gap-4 text-xl text-white/75" data-id="element-150" data-mp="5h9jgjgf9son">
                <CheckIcon className="mt-1.5 h-5 w-5 shrink-0 text-gold" aria-hidden="true" data-id="element-151" data-mp="ag2vs8jz3dn8" />
                <span data-id="element-152" data-mp="2ljc5w4bawrk7">{line}</span>
              </li>)}
          </ul>

          <p className="mt-10 border-l-2 border-gold pl-6 text-lg leading-relaxed text-white" data-id="element-153" data-mp="30770jq8vd5zx">
            {forYou.close}
          </p>
        </div>
      </div>
    </section>;
}